export const scrollToElement = (selector: string, setting: ScrollIntoViewOptions = {}) => {
  const element = document.querySelector<HTMLDivElement>(selector);
  element && element.scrollIntoView({ behavior: 'smooth', ...setting });
}

export const copyTextToClipboard = (text: string) => {
  var textArea = document.createElement("textarea");
  textArea.value = text;

  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } finally {
    document.body.removeChild(textArea);
  }
}
